import type { CSSProperties, HTMLAttributes } from 'react';

/**
 * Ícone Material Symbols (Outlined) — o mesmo `<span class="material-symbols-outlined">nome</span>`
 * do protótipo Lumina, embrulhado. A fonte é carregada por `<link>` em cada app.
 *
 * `fill` liga o eixo FILL (equivale ao `style="font-variation-settings: 'FILL' 1"` do protótipo).
 */
export function MSym({
  name,
  className = '',
  fill = false,
  style,
  ...props
}: {
  name: string;
  className?: string;
  fill?: boolean;
} & Omit<HTMLAttributes<HTMLSpanElement>, 'style' | 'children'> & { style?: CSSProperties }) {
  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={fill ? { fontVariationSettings: "'FILL' 1", ...style } : style}
      aria-hidden="true"
      {...props}
    >
      {name}
    </span>
  );
}
